<template>
    <path d="M16.308 32.449c0-.172-.135-.306-.308-.306-1.52 0-2.77-1.244-2.77-2.755 0-.172-.134-.306-.307-.306s-.308.134-.308.306c0 1.856 1.52 3.367 3.385 3.367.173 0 .308-.134.308-.306zM3.5 26.939h25c-3.442-3.865-5.115-9.107-5.115-15.919 0-2.468-2.347-6.122-7.385-6.122S8.615 8.552 8.615 11.02c0 6.812-1.673 12.054-5.115 15.919zm28.5 0c0 1.34-1.115 2.449-2.462 2.449h-8.615c0 2.697-2.211 4.898-4.923 4.898s-4.923-2.2-4.923-4.898H2.462c-1.347 0-2.462-1.11-2.462-2.45 2.846-2.39 6.154-6.677 6.154-15.918 0-3.673 3.058-7.69 8.154-8.437-.096-.23-.154-.478-.154-.746C14.154.823 14.98 0 16 0c1.02 0 1.846.823 1.846 1.837 0 .268-.058.516-.154.746 5.096.746 8.154 4.764 8.154 8.437 0 9.241 3.308 13.527 6.154 15.919z"/>
</template>

<script>
export default {
    name: 'bellIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 35');
    }
};
</script>
